module.exports = __webpack_public_path__ + "static/media/keyboard-arrow-up.24a93bb6.svg";